import { render, staticRenderFns } from "./OzInput.vue?vue&type=template&id=7934fb6f&scoped=true&"
import script from "./OzInput.vue?vue&type=script&lang=ts&setup=true&"
export * from "./OzInput.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./OzInput.vue?vue&type=style&index=0&id=7934fb6f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7934fb6f",
  null
  
)

export default component.exports